<template>
  <Band class="brand-about-page">
    <Container>
      <Markdown
        v-if="partner.details"
        as="p"
        :text="partner.details"
      />
    </Container>
  </Band>
</template>

<script setup lang="ts">
import type { Partner } from '~/types/partner'

definePageMeta({
  source: 'brand-generic'
})

const partner = useAttrs().partner as Partner
</script>

<style>
.brand-about-page {
  a {
    @apply text-brand hover:text-brand-hover;
  }
}
</style>
